import { ButtonHTMLAttributes, forwardRef } from "react";
// Simple classNames utility to merge class strings
function cn(...classes: (string | undefined | false)[]) {
  return classes.filter(Boolean).join(" ");
}

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "default" | "secondary";
  size?: "sm" | "lg";
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = "default", size = "sm", ...props }, ref) => {
    const baseStyles = "rounded-md font-medium transition";
    const sizeStyles = {
      sm: "px-4 py-2 text-sm",
      lg: "px-8 py-4 text-lg",
    };
    const variantStyles = {
      default: "bg-[#f98715] text-white hover:bg-[#d87710]",
      secondary: "bg-white text-[#f98715] hover:bg-gray-100",
    };

    return (
      <button
        ref={ref}
        className={cn(baseStyles, sizeStyles[size], variantStyles[variant], className)}
        {...props}
      />
    );
  }
);

Button.displayName = "Button";
export { Button };
